/**
 * Where to go after signing in: a path on this site from `?next=` (for example back to a room),
 * else /me. Anything that could leave the site ("//evil.example", "https://…", "/\\evil") is ignored.
 */
export function nextPath(search: string): string {
  const next = new URLSearchParams(search).get("next") ?? "";
  return /^\/(?![/\\])[\w\-./?=&#%]*$/.test(next) ? next : "/me";
}

/** A path on this site to come back to after checkout (the api checks it the same way). */
export function passBack(search: string): string | null {
  const back = new URLSearchParams(search).get("back") ?? "";
  return /^\/[A-Za-z0-9/_-]{0,100}$/.test(back) ? back : null;
}
